import RunStateBadge from "components/Run/elements/StateBadge";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { getStackPullRequestLatestRun } from "../../../helpers";
import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestStatusCell = ({
  item: pullRequest,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  const latestRun = getStackPullRequestLatestRun(pullRequest.runs);

  return (
    <StackPullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!latestRun && <TableCellEmpty />}

      {!!latestRun && <RunStateBadge state={latestRun.state} />}
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestStatusCell;
